import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const deleteCollection = (CollectionID) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.DELETE_COLLECTION(CollectionID)
  );
};

export default deleteCollection;
